exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.chat-title{display:flex;overflow:hidden;text-overflow:ellipsis;white-space:nowrap;align-items:center\n}\n.chat-title .username{max-width:100%;text-overflow:ellipsis;white-space:nowrap;display:inline;word-wrap:break-word;overflow:hidden;text-overflow:ellipsis\n}\n.chat-title .username .emoji{width:14px;height:14px;vertical-align:middle;-o-object-fit:contain;object-fit:contain\n}\n.chat-title .Avatar{width:23px;height:23px;margin-right:.5em;border-radius:10px;border-radius:var(--avatarAltRadius, 10px)\n}\n.chat-title .Avatar.animated::before{display:none\n}", ""]);

// exports
